import { completeExternalConnectionAuth as _completeExternalConnectionAuth } from '@griply/services';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const completeExternalConnectionAuth = (connectionToken: string) =>
  _completeExternalConnectionAuth({
    functions: getFunctions(),
    httpsCallable,
    payload: { connectionToken },
  });
